
import SectionIntroV1 from '~/components/sections/project/intro/SectionIntroV1.vue'
import SectionIntroV2 from '~/components/sections/project/intro/SectionIntroV2.vue'

export default {
  name: 'SectionIntro',
  components: {},
  props: {
    variant: {
      required: true,
      type: String,
      default: ''
    },
    data: {
      required: true,
      type: Object,
      default: function () {
        return {}
      }
    },
    orderNo: {
      required: true,
      type: Number,
      default: 0
    },
    hash: {
      required: true,
      type: String,
      default: ''
    }
  },
  data() {
    return {
      componentVariant: null
    }
  },
  watch: {
    variant: function (newVariant, oldVariant) {
      this.handleVariant(newVariant)
    }
  },
  created() {
    this.handleVariant(this.variant)
  },
  methods: {
    handleVariant(variant) {
      switch (variant) {
        case 'v2':
          this.componentVariant = SectionIntroV2
          break
        default:
          this.componentVariant = SectionIntroV1
          break
      }
    }
  }
}
